import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import ComingSoon from "../views/user/ComingSoon";
import Homepage from "../views/user/Homepage";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Search from "../views/user/Search";
import Blogs from "../views/user/Blogs";
import Vendor from "../views/user/Vendor";
import Cart from "../views/user/Cart";
import Contact from "../views/user/Contact";
import ProductDetails from "../views/user/ProductDetails";
import Checkout from "../views/user/Checkout";
import UserAccountRoutes from "./UserAccountRoutes";
import AuthenticationForm, { ResetForm } from "../components/forms/authentication/AuthenticationForm";
import styled from "styled-components";
import { useAuth } from "../hooks/useAuth";
import { useAppContext } from "../context/useAppContext";
import PrivateRoute from "./PrivateRoute";
import ProtectedRoute from "./ProtectedRoute";
import Thankyou from "../views/user/Thankyou";
import { useEffect } from "react";
import BlogDetails from "../views/user/BlogDetails";
import GroupBuy from "../views/user/GroupBuy";
import PrivacyPolicy from "../views/user/PrivacyPolicy";
import ReturnPolicy from "../views/user/ReturnPolicy";
import HelpCenter from "../views/user/HelpCenter";
import AboutUs from "../views/user/AboutUs";
import TermsAndConditions from "../views/user/TermsAndConditions";
import Careers from "../views/user/Careers";
import SupportChat from "../components/helpAndSupport/SupportChat";
import Logout from "../views/user/Logout";
import SessionLogin from "../components/SessionLogin";
import Thankyou2 from "../views/user/Thankyou2";
import PaymentFailed from "../views/user/PaymentFailed";
import Thankyou3 from "../views/user/Thankyou3";
import CheckoutDraft from "../views/user/CheckoutDraft";
import Clearance from "../views/user/Clearance";
// import Sitemap from "../views/user/Sitemap";
// import CookiePreferences from "../views/user/CookiePreferences";
// import Unsubscribe from "../views/user/Unsubscribe";

const AuthPopupStyle = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const UserRoutes = () => {
  const { isAuthForm, setIsAuthForm, isResetForm, setIsResetForm } = useAppContext();
  const isLoggedIn = useAuth();
  const location = useLocation();

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [location.pathname]);

  useEffect(() => {
    window.history.scrollRestoration = "manual"; // Prevents the default behavior of restoring scroll on back
    window.scrollTo(0, 0);
  
    return () => {
      window.history.scrollRestoration = "auto"; // Restore default behavior on cleanup
    };
  }, [location.pathname]);

  useEffect(() => {
    setIsAuthForm(false)
    // return () => setIsAuthForm(false)
  }, [isResetForm, setIsAuthForm])

  return (
    <>
      {isAuthForm && !isLoggedIn && (
        <AuthPopupStyle>
          <AuthenticationForm setIsAuthForm={setIsAuthForm} />
        </AuthPopupStyle>
      )}

      {isResetForm && !isLoggedIn && (
        <AuthPopupStyle>
          <ResetForm setIsResetForm={setIsResetForm} />
        </AuthPopupStyle>
      )}
      {location.pathname !== "/" || isLoggedIn ? <Header setIsAuthForm={setIsAuthForm} /> : null}
      <Routes>
        <Route exact path="/" element={isLoggedIn ? <Homepage /> : <ComingSoon />} />
        <Route element={<ProtectedRoute />}>
        <Route path="/search" element={<Search />} />
        <Route
          path="/categories"
          element={
            <Search
              showCategory={true}
              showProducts={false}
              showRelated={false}
            />
          }
        />
        <Route path="/group-buy" element={<GroupBuy />} />
        <Route path="/clearance" element={<Clearance />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog/:blogId" element={<BlogDetails />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/seller/:sellerId" element={<Vendor />} />
        <Route path="/product/:productId" element={<ProductDetails />} />
        <Route path="/contact" element={<Contact />} />
        <Route element={<PrivateRoute />}>
          <Route path="/checkout" element={<Checkout />} />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route path="/checkout-order-draft/:draftId" element={<CheckoutDraft />} />
        </Route>
        <Route path="/thankyou2" element={<Thankyou2 />} />
        <Route path="/thank-you" element={<Thankyou3 />} />
        <Route path="/payment-failed" element={<PaymentFailed />} />
        <Route path="/thankyou" element={<Thankyou />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        {/* Disabled routes - Footer links
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/cookie-preferences" element={<CookiePreferences />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        */}
        <Route path="/return-policy" element={<ReturnPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/help" element={<HelpCenter />} />
        <Route path="/chat-support/:ticketId" element={<SupportChat />} />
          <Route path="/logout" element={<Logout />} />
        <Route path="/account/*" element={<UserAccountRoutes />} />
        </Route>
        {/* Session route must be outside ProtectedRoute to allow token-based login */}
        <Route path="/session" element={<SessionLogin />} />
        <Route path="*" element={<Navigate to={"/"} replace />} />
      </Routes>
      {location.pathname !== "/" || isLoggedIn ? <Footer /> : null}
    </>
  );
};

export default UserRoutes;
